import { Injectable } from '@angular/core';
import { PageName } from 'src/app/core/enums';
import { ErrorObj } from 'src/app/core/models';
import { ErrorService } from 'src/app/core/services/error.service';
import { UserService } from 'src/app/core/user/user.service';
import { UserQuery } from 'src/app/core/user/user.query';
import { SignupForm } from '../models/SignupForm';
import { RoutingService } from './routing.service';
import { environment } from 'src/environments/environment';
import { FormStage } from '../enums/FormStage';
import { HttpErrorResponse } from '@angular/common/http';
import { OtpService } from './otp.service';
import { ChannelService } from 'src/app/home/channel/channel.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { AnalyticsEvent } from 'src/app/core/enums/AnalyticsEvent';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { Router } from '@angular/router';
import { LoginRequest } from 'src/app/core/models/LoginRequest';

@Injectable()
export class RegisterService {

  constructor(
    private routingService: RoutingService,
    private userService: UserService,
    private userQuery: UserQuery,
    private errorService: ErrorService,
    private otpService: OtpService,
    private channelService: ChannelService,
    private analyticsService: AnalyticsService,
    private previousRouteService : PreviousRouteService,
    private router : Router
  ) { }

  async onSignup(dt: any) {
    try {
      if (dt.signupForm.stage === FormStage.Signup) {
        let loginRequest: LoginRequest = {
          mobileNo: dt.signupForm.mobileNo,
          password: dt.signupForm?.password,
          otpCode: dt.signupForm?.otpCode
        }

        let signUpRespDt = await this.userService.signup({ ...dt.signupForm });

        if (signUpRespDt instanceof HttpErrorResponse === false) {
          await this.userService.login(loginRequest);
          this.analyticsService.logEvents(AnalyticsEvent.sign_up, { method: 'web' });
        }

        await this.channelService.switchChannel(this.channelService.selectedChannel ?
          this.channelService.selectedChannel.channelTag : environment.odaringChannel);
        this.onSignupSuccess();
      }
    } catch (ee) {
      if (ee instanceof HttpErrorResponse) {
        this.onSignupError(ee.error, dt.signupForm);
      }
      this.setError(ee);
    }
  }

  async otpSignUp(signupForm: any) {
    return await this.userService.signup({ ...signupForm });
  }

  onSignupError(err: ErrorObj, dt: SignupForm) {
    let errEx1 = {
      "errorData": [
        {
          "errorField": "MobileNo",
          "errorMessage": "Invalid mobile number, should be in 10 digits"
        }
      ],
      "type": "Invalid input argument",
      "title": "One or more validation errors occured.",
      "status": 400,
      "detail": "Invalid mobile number, should be in 10 digits",
      "instance": "/api/customer/registercustomer"
    };

    let errEx2 = {
      "headers": {
        "normalizedNames": {},
        "lazyUpdate": null
      },
      "status": 500,
      "statusText": "Internal Server Error",
      "url": "https://cxmapidev.azurewebsites.net/api/customer/registercustomer",
      "ok": false,
      "name": "HttpErrorResponse",
      "message": "Http failure response for https://cxmapidev.azurewebsites.net/api/customer/registercustomer: 500 Internal Server Error",
      "error": "System.NullReferenceException: Object reference not set to an instance of an object.\r\n   at CXM.Frontend.API.Filter.CustomExceptionHandler.OnExceptionAsync(ExceptionContext context) in C:\\ZeoniqRepo\\cxm.api\\CXM\\CXM.Frontend.API\\Filter\\CustomExceptionHandler.cs:line 19\r\n   at Microsoft.AspNetCore.Mvc.Infrastructure.ResourceInvoker.Next(State& next, Scope& scope, Object& state, Boolean& isCompleted)\r\n   at Microsoft.AspNetCore.Mvc.Infrastructure.ResourceInvoker.<InvokeNextResourceFilter>g__Awaited|24_0(ResourceInvoker invoker, Task lastTask, State next, Scope scope, Object state, Boolean isCompleted)\r\n   at Microsoft.AspNetCore.Mvc.Infrastructure.ResourceInvoker.Rethrow(ResourceExecutedContextSealed context)\r\n   at Microsoft.AspNetCore.Mvc.Infrastructure.ResourceInvoker.Next(State& next, Scope& scope, Object& state, Boolean& isCompleted)\r\n   at Microsoft.AspNetCore.Mvc.Infrastructure.ResourceInvoker.<InvokeFilterPipelineAsync>g__Awaited|19_0(ResourceInvoker invoker, Task lastTask, State next, Scope scope, Object state, Boolean isCompleted)\r\n   at Microsoft.AspNetCore.Mvc.Infrastructure.ResourceInvoker.<InvokeAsync>g__Awaited|17_0(ResourceInvoker invoker, Task task, IDisposable scope)\r\n   at Microsoft.AspNetCore.Routing.EndpointMiddleware.<Invoke>g__AwaitRequestTask|6_0(Endpoint endpoint, Task requestTask, ILogger logger)\r\n   at Microsoft.AspNetCore.Authorization.AuthorizationMiddleware.Invoke(HttpContext context)\r\n   at CXM.Frontend.API.Middlewares.MultiTenantMiddleware.InvokeAsync(HttpContext context, DatabaseContext databaseContext, WorkContext currentWorkContext, ISubscriptionService subscriptionService) in C:\\ZeoniqRepo\\cxm.api\\CXM\\CXM.Frontend.API\\Middlewares\\MultiTenantMiddleware.cs:line 70\r\n   at Microsoft.AspNetCore.Authentication.AuthenticationMiddleware.Invoke(HttpContext context)\r\n   at Microsoft.AspNetCore.Diagnostics.DeveloperExceptionPageMiddleware.Invoke(HttpContext context)\r\n\r\nHEADERS\r\n=======\r\nAccept: application/json, text/plain, */*\r\nAccept-Encoding: gzip, deflate, br\r\nAccept-Language: en-US,en;q=0.9,zh-CN;q=0.8,zh;q=0.7,zh-TW;q=0.6\r\nConnection: Keep-Alive\r\nContent-Language: en\r\nContent-Length: 127\r\nContent-Type: application/json\r\nHost: cxmapidev.azurewebsites.net\r\nMax-Forwards: 10\r\nReferer: http://localhost:4200/\r\nUser-Agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.182 Safari/537.36\r\nsec-ch-ua: \"Chromium\";v=\"88\", \"Google Chrome\";v=\"88\", \";Not A Brand\";v=\"99\"\r\nX-Signature: b27792f2b786e89fc469f5b2648d942b49b944fd614804f5a94ec847fe5d4319:1613623278:7c47f911-b1f2-45e0-9b38-5e7f6e02148d\r\nsec-ch-ua-mobile: ?0\r\napi-version: 1\r\nSubscriptionID: 00009\r\nOrigin: http://localhost:4200\r\nSec-Fetch-Site: cross-site\r\nSec-Fetch-Mode: cors\r\nSec-Fetch-Dest: empty\r\nX-WAWS-Unencoded-URL: /api/customer/registercustomer\r\nCLIENT-IP: 202.186.154.138:55751\r\nX-ARR-LOG-ID: 01cad6a8-c0fe-47a9-9e8e-29596edad8a2\r\nDISGUISED-HOST: cxmapidev.azurewebsites.net\r\nX-SITE-DEPLOYMENT-ID: cxmapidev\r\nWAS-DEFAULT-HOSTNAME: cxmapidev.azurewebsites.net\r\nX-Original-URL: /api/customer/registercustomer\r\nX-Forwarded-For: 202.186.154.138:55751\r\nX-ARR-SSL: 2048|256|C=US, O=Microsoft Corporation, CN=Microsoft RSA TLS CA 01|CN=*.azurewebsites.net\r\nX-Forwarded-Proto: https\r\nX-AppService-Proto: https\r\nX-Forwarded-TlsVersion: 1.2\r\n"
    };

    let errEx3 = {
      "errorData": [
        {
          "errorField": "Email",
          "errorMessage": "abang@zeoniq.com"
        }
      ],
      "type": "about:blank",
      "title": "Email had been used",
      "status": 400,
      "detail": "Email abang@zeoniq.com has already been registered by another user",
      "instance": "/api/customer/registercustomer"
    };

    let errEx4 = {
      "errorData": null,
      "type": "about:blank",
      "title": "Invalid OTP to verify mobile no",
      "status": 500,
      "detail": "Invalid OTP",
      "instance": "/api/customer/registercustomer"
    }

  }

  onSignupSuccess() {
    let previousRoute = this.previousRouteService.getPreviousRoute();
    localStorage.removeItem('previousRoute');
    this.router.navigateByUrl(previousRoute.routeName);
  }

  selectUser() {
    return this.userQuery.getEntity(environment.localGenCustomerId);
  }

  setError(errorObj: ErrorObj) {
    this.errorService.insertErrorObj(errorObj);
    this.userService.error(errorObj);
  }

  navigateToPage(pageName: PageName) {
    const rtSv = this.routingService;
    rtSv.navigate(pageName);
  }
}
